import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

// date,
@Component({
    selector: 'app-date',
    template: `
      <div [formGroup]="form">
        <input
        [attr.type]="field.type"
        class="form-control"
        [id]="field.name"
        [name]="field.name"
        [formControlName]="field.name"
        [ngClass]="{'is-invalid': isTouched && !isValid}" [min]="field.min"
        [max]="field.max">
      </div>
    `,
    standalone: false
})
export class DateComponent implements OnChanges {
  @Input() field: any = {};
  @Input() form!: UntypedFormGroup;
  algo = true;
  get isValid(): any {
    return this.form.controls[this.field.name].valid;
  }
  get isDirty(): any {
    return this.form.controls[this.field.name].dirty;
  }
  get isTouched(): any {
    return this.form.controls[this.field.name].touched;
  }

  constructor() {

  }

  ngOnChanges(changes: SimpleChanges): void {
    this.field = changes.field.currentValue;
    this.form = changes.form.currentValue;
  }
}
